module.exports = __webpack_public_path__ + "img/elvis-fanday-83.975046e7.jpg";